import React from 'react';

export default () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36 25a3 3 0 01-3-3v-9h6v9a3 3 0 01-3 3z" fill="#fff" />
    <path d="M39 13H20.9A9 9 0 003 14v29h42V13h-6z" fill="#fff" />
    <path
      opacity=".3"
      d="M12 9a5 5 0 10.5 10 4 4 0 114.5-4.5V14a5 5 0 00-5-5zM7 43h2V27h8v-2H7v18zM24 25a3 3 0 003-3v-9h-6v9a3 3 0 003 3zM36 25a3 3 0 003-3v-9h-6v9a3 3 0 003 3zM45 35H21v8h24v-8z"
      fill="#005CB7"
    />
    <path
      d="M45 13H21v30h24V13zM12 5a9 9 0 019 9v29H3V14a9 9 0 019-9v0z"
      stroke="#005CB7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 14a5 5 0 10-10 0 5 5 0 0010 0zM24 25a3 3 0 01-3-3v-9h6v9a3 3 0 01-3 3v0zM30 25a3 3 0 01-3-3v-9h6v9a3 3 0 01-3 3v0zM36 25a3 3 0 01-3-3v-9h6v9a3 3 0 01-3 3v0zM42 25a3 3 0 01-3-3v-9h6v9a3 3 0 01-3 3v0zM17 25H7v18h10V25zM45 35H21v8h24v-8z"
      stroke="#005CB7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
